import i18n from '../../plugins/i18n';

const createMap = (arr = [], labelKey, translationPrefix = '', valueKey = 'id', condition) =>

  arr.reduce((acc, curr) => {
    if (condition && !condition(curr)) return acc;
    return {
      ...acc,
      [curr[valueKey]]: {
        ...curr,
        value: curr[valueKey],
        label: curr[labelKey] || i18n.tc(`${translationPrefix}.${curr[valueKey]}`),
      },
    };
  }, {});

const getters = {
  entityTypeMap({ tenDlcEnums: { entity_type: entityType = [] } }) {
    return createMap(entityType, 'display_name', 'brands.entityTypeOptions');
  },
  altBusinessIdTypeMap({ tenDlcEnums: { alt_business_id_type: businessIdType = [] } }) {
    return createMap(businessIdType, 'display_name', 'brands.businessIdTypeOptions');
  },
  brandRelationshipMap({ tenDlcEnums: { brand_relationship: brandRelationship = [] } }) {
    return createMap(brandRelationship, 'display_name');
  },
  brandStatussMap({ tenDlcEnums: { brand_status: brandStatus = [] } }) {
    return createMap(brandStatus, 'display_name');
  },
  tmoBrandTierMap({ tenDlcEnums: { tmo_brand_tier: brandTier = [] } }) {
    return createMap(brandTier, 'display_name');
  },
  stockExchangeMap({ tenDlcEnums: { stock_exchange: stockExchange = [] } }) {
    return createMap(stockExchange, 'description');
  },
  verticalMap({ tenDlcEnums: { vertical = [] } }) {
    return createMap(vertical, 'description');
  },
  campaignStatusMap({ tenDlcEnums: { campaign_status: status = [] } }) {
    return createMap(status, 'description');
  },
  mnoMap({ tenDlcEnums: { mno = [] } }) {
    return createMap(mno, 'mno');
  },
  usecaseMap({ tenDlcEnums: { usecase } }) {
    return createMap(usecase, 'display_name');
  },
  specialUsecaseMap({ tenDlcEnums: { usecase } }) {
    const condition = ({ classification }) => classification === 'SPECIAL';
    return createMap(usecase, 'display_name', 'campaigns.usecases', 'id', condition);
  },
  standardUsecaseMap({ tenDlcEnums: { usecase } }) {
    const condition = ({ classification }) => classification === 'STANDARD';
    return createMap(usecase, 'display_name', 'campaigns.usecases', 'id', condition);
  },
  tenDlcEnumsAreLoaded({ tenDlcEnums }) {
    return Object.keys(tenDlcEnums).length > 0;
  },
  initialSetupFees({ tenDlcEnums: { initial_setup_fees: initialSetupFees = 0 } }) {
    return initialSetupFees;
  },
};

export default getters;
